// reviews-component-manual.js
// This file should be added to your theme's assets directory

document.addEventListener('DOMContentLoaded', function() {
  // Configuration
  const config = {
    // Define your filter topics - should match the topics you use in the Shopify admin
    topics: [
      'Quality',
      'Customer Service',
      'Shipping',
      'Value for Money',
      'Product Features'
    ],
    
    // DOM element where reviews are displayed
    reviewsContainerId: 'all-reviews-container',
    filtersContainerId: 'reviews-filters-container'
  };
  
  // Main reviews state
  let allReviews = [];
  let filteredReviews = [];
  let activeFilters = {
    source: null,
    topic: null,
    minRating: 1
  };
  let currentSort = 'newest';
  
  // Initialize the component
  init();
  
  function init() {
    // Get all reviews from the DOM
    collectReviewsFromDOM();
    
    // Create filter UI
    createFilterUI();
    
    // Add filter event listeners
    addFilterEventListeners();
    
    // Add read more/less event listeners
    addReadMoreListeners();
  }
  
  // Add event listeners to Read More/Less buttons
  function addReadMoreListeners() {
    document.querySelectorAll('.read-more-btn').forEach(btn => {
      btn.addEventListener('click', function() {
        const contentDiv = this.closest('.review-content');
        contentDiv.classList.toggle('expanded');
        
        // Update button text based on state
        if (contentDiv.classList.contains('expanded')) {
          this.textContent = '';  // Text will be added via CSS ::after
          this.setAttribute('aria-expanded', 'true');
        } else {
          this.textContent = 'Read More';
          this.setAttribute('aria-expanded', 'false');
        }
      });
    });
  }
  
  // Collect all reviews from the DOM
  function collectReviewsFromDOM() {
    const reviewCards = document.querySelectorAll('.review-card');
    
    allReviews = Array.from(reviewCards).map(card => {
      // Get topics from the data attribute
      const topicsString = card.dataset.topics || '';
      const topics = topicsString.split(',').map(topic => topic.trim()).filter(topic => topic);
      
      // Parse the date for sorting
      const dateText = card.querySelector('.review-date').textContent.replace('via ', '');
      const dateParts = dateText.split(' ');
      // Handle different date formats
      let dateObj;
      try {
        // Try to parse the date
        if (dateParts.length >= 3) {
          // Format like "February 15, 2025"
          const monthIndex = [
            'january', 'february', 'march', 'april', 'may', 'june', 
            'july', 'august', 'september', 'october', 'november', 'december'
          ].indexOf(dateParts[0].toLowerCase());
          
          // Remove comma if present
          const day = parseInt(dateParts[1].replace(',', ''));
          const year = parseInt(dateParts[2]);
          
          if (monthIndex !== -1 && !isNaN(day) && !isNaN(year)) {
            dateObj = new Date(year, monthIndex, day);
          }
        }
      } catch (e) {
        console.error('Error parsing date:', e);
      }
      
      // Fallback to current date if parsing fails
      if (!dateObj || isNaN(dateObj.getTime())) {
        dateObj = new Date();
      }
      
      // Store the original card for later reference
      return {
        element: card,
        source: card.dataset.source,
        rating: parseInt(card.dataset.rating) || 5,
        topics: topics,
        date: dateObj
      };
    });
    
    // Initialize filtered reviews with all reviews
    filteredReviews = [...allReviews];
    
    // Apply initial sorting (newest first)
    sortReviews();
  }
  
  // Create the filter UI
  function createFilterUI() {
    const filtersContainer = document.getElementById(config.filtersContainerId);
    if (!filtersContainer) return;
    
    // Get unique sources from reviews
    const sources = [...new Set(allReviews.map(review => review.source))];
    
    // Source filter
    let sourceOptionsHTML = sources.map(source => 
      `<button class="filter-btn source-btn" data-source="${source}">${source}</button>`
    ).join('');
    
    const sourceFilterHTML = `
      <div class="filter-group">
        <h3>Filter by Source</h3>
        <div class="filter-options">
          <button class="filter-btn source-btn active" data-source="all">All Sources</button>
          ${sourceOptionsHTML}
        </div>
      </div>
    `;
    
    // Get unique topics from reviews
    let allTopics = [];
    allReviews.forEach(review => {
      allTopics = [...allTopics, ...review.topics];
    });
    const uniqueTopics = [...new Set(allTopics)];
    
    // Topic filter
    let topicOptionsHTML = uniqueTopics.map(topic => 
      `<button class="filter-btn topic-btn" data-topic="${topic}">${topic}</button>`
    ).join('');
    
    const topicFilterHTML = `
      <div class="filter-group">
        <h3>Filter by Topic</h3>
        <div class="filter-options">
          <button class="filter-btn topic-btn active" data-topic="all">All Topics</button>
          ${topicOptionsHTML}
        </div>
      </div>
    `;
    
    // Date sort filter
    const sortFilterHTML = `
      <div class="filter-group">
        <h3>Sort By Date</h3>
        <div class="filter-options">
          <button class="filter-btn sort-btn active" data-sort="newest">Newest First</button>
          <button class="filter-btn sort-btn" data-sort="oldest">Oldest First</button>
        </div>
      </div>
    `;
    
    // Rating filter
    const ratingFilterHTML = `
      <div class="filter-group">
        <h3>Minimum Rating</h3>
        <div class="filter-options star-rating-filter">
          <button class="star-btn" data-rating="1">★</button>
          <button class="star-btn" data-rating="2">★</button>
          <button class="star-btn" data-rating="3">★</button>
          <button class="star-btn" data-rating="4">★</button>
          <button class="star-btn" data-rating="5">★</button>
          <span class="star-filter-text">All ratings</span>
        </div>
      </div>
    `;
    
    // Combine all filters - reordered to put date sorting above star rating
    filtersContainer.innerHTML = sourceFilterHTML + topicFilterHTML + sortFilterHTML + ratingFilterHTML;
  }
  
  // Add event listeners to filter buttons
  function addFilterEventListeners() {
    // Source filter buttons
    document.querySelectorAll('.source-btn').forEach(btn => {
      btn.addEventListener('click', function() {
        document.querySelectorAll('.source-btn').forEach(b => b.classList.remove('active'));
        this.classList.add('active');
        activeFilters.source = this.dataset.source === 'all' ? null : this.dataset.source;
        applyFilters();
      });
    });
    
    // Topic filter buttons
    document.querySelectorAll('.topic-btn').forEach(btn => {
      btn.addEventListener('click', function() {
        document.querySelectorAll('.topic-btn').forEach(b => b.classList.remove('active'));
        this.classList.add('active');
        activeFilters.topic = this.dataset.topic === 'all' ? null : this.dataset.topic;
        applyFilters();
      });
    });
    
    // Star rating filter
    const starButtons = document.querySelectorAll('.star-btn');
    const starFilterText = document.querySelector('.star-filter-text');
    
    starButtons.forEach((btn, index) => {
      btn.addEventListener('click', function() {
        const rating = parseInt(this.dataset.rating);
        
        // Toggle active state for clicked star and those to its left
        starButtons.forEach((star, i) => {
          if (i < rating) {
            star.classList.add('active');
          } else {
            star.classList.remove('active');
          }
        });
        
        // Update active filter and text
        activeFilters.minRating = rating;
        
        if (rating === 1 && !starButtons[0].classList.contains('active')) {
          // If user clicked on star 1 when it was already active, reset to show all
          activeFilters.minRating = 1;
          starFilterText.textContent = 'All ratings';
          starButtons[0].classList.remove('active');
        } else {
          starFilterText.textContent = `${rating}+ stars`;
        }
        
        applyFilters();
      });
    });
    
    // Date sorting buttons
    document.querySelectorAll('.sort-btn').forEach(btn => {
      btn.addEventListener('click', function() {
        document.querySelectorAll('.sort-btn').forEach(b => b.classList.remove('active'));
        this.classList.add('active');
        currentSort = this.dataset.sort;
        sortReviews();
        applyFilters();
      });
    });
  }
  
  // Sort reviews by date
  function sortReviews() {
    // Sort all reviews
    allReviews.sort((a, b) => {
      if (currentSort === 'newest') {
        return b.date - a.date;
      } else {
        return a.date - b.date;
      }
    });
    
    // Also sort filtered reviews
    filteredReviews.sort((a, b) => {
      if (currentSort === 'newest') {
        return b.date - a.date;
      } else {
        return a.date - b.date;
      }
    });
    
    // Get the parent container
    const reviewsContainer = document.getElementById(config.reviewsContainerId);
    
    // Rearrange DOM elements to match the sorted order
    filteredReviews.forEach(review => {
      reviewsContainer.appendChild(review.element);
    });
  }
  
  // Apply filters to all reviews
  function applyFilters() {
    // Reset visibility of all reviews
    allReviews.forEach(review => {
      review.element.style.display = 'none';
    });
    
    // Filter reviews based on active filters
    filteredReviews = allReviews.filter(review => {
      // Filter by source
      if (activeFilters.source && review.source !== activeFilters.source) {
        return false;
      }
      
      // Filter by topic
      if (activeFilters.topic && !review.topics.includes(activeFilters.topic)) {
        return false;
      }
      
      // Filter by rating
      if (review.rating < activeFilters.minRating) {
        return false;
      }
      
      return true;
    });
    
    // Show filtered reviews
    filteredReviews.forEach(review => {
      review.element.style.display = 'block';
    });
    
    // Show message if no reviews match filters
    const reviewsContainer = document.getElementById(config.reviewsContainerId);
    if (reviewsContainer && filteredReviews.length === 0) {
      // Check if message already exists
      if (!document.querySelector('.no-reviews-message')) {
        const noReviewsMessage = document.createElement('div');
        noReviewsMessage.className = 'no-reviews-message';
        noReviewsMessage.textContent = 'No reviews match your filters. Try adjusting your criteria.';
        reviewsContainer.appendChild(noReviewsMessage);
      }
    } else {
      // Remove message if it exists
      const noReviewsMessage = document.querySelector('.no-reviews-message');
      if (noReviewsMessage) {
        noReviewsMessage.remove();
      }
    }
  }
});